module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAJxJREFUOE/dU9sNwjAQsyeBUdpJKJNQJgE26SjtJCaukgihlERU/HBScso9HMUXE9EkHQGc0rniF5J319CbpCG4CwAHx7hKGCnn+jPJKQG4GSSvkhT8Gn+3lAs+15cAbgB8Q8kmkv1HgBYOfgtQmcaD5FzjYHOcJjlObZvE3Rz8wRN2c/AtQAfAX3hVWINZVH0W04siDw3NLslyfgLeqpcR0JpPJQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/workOrder_w.png
// module id = qVg4
// module chunks = 3